"use strict"

import React from "react"

import { withZoomState } from "../../config/ZoomConfigProvider"
import SetOffsetTrigger from "../../../shared_components/graphing/plotting/widgets/SetOffsetTrigger"
import ExcelTravelerButton from "../../graphing/modals/ExcelTravelerButton"
import {
  getFormattedMessage,
  id_accessor,
  isLTPM,
  multi_run_view,
} from "../../../components/shared_components_registration"
import { RunInfoPopover } from "../../../components/shared_components_registration_overflow"
import LabelingCompleteLabel from "../../graphing/plotting/widgets/ToggleRunLabelsButton/LabelingCompleteLabel"

const { RunFilesDownloader, getExportBaseName, get_updated_time_label } = multi_run_view

function RunHeaderBar({
  run,
  width,
  onDragStart,
  perRunTimeOffsets, // withZoomState
  updateTimeOffset, // withZoomState
  exportBaseName = "",
  scrollable_px = 0,
  px,
  py,
  updateRunList,
  canDownloadRawData = false,
  canUnselectRun = true,
  canAlterOffset = true,
  runs = [],
  labelOffset,
  intl,
}) {
  const getTextStr = (id, msg) => getFormattedMessage(id, msg, true, intl)
  const toggleRun = (runID, active) => {
    if (!updateRunList) return

    if (active) {
      if (runs.indexOf(runID) < 0) {
        updateRunList([...runs, runID])
      }
    } else {
      if (runs.indexOf(runID) >= 0) {
        updateRunList(runs.filter((r) => r !== runID))
      }
    }
  }

  const runID = run[id_accessor]
  const spanStyle = {
    cursor: "pointer",
    paddingLeft: "5px",
    paddingRight: "5px",
  }

  const runLabel = run.loading
    ? `${getTextStr("general.loading", "Loading")}...`
    : run.err
      ? getTextStr("general.server.error", "Error! Could not process request")
      : getExportBaseName(run, true, "\u2014") || ""

  const detailStyle = {
    display: "inline-block",
    padding: "1px",
    borderRadius: "3px",
    verticalAlign: "text-bottom",
    marginLeft: "5px",
    fontSize: "60%",
  }

  const translation_px_obj = { loaded: 185, loading: isLTPM ? 65 : 75 }

  /*
   * We need to make this a positioning root (and the "container" for the popup)
   * in order to prevent react-boostrap from getting overly-clever when opening
   * the popup.  If not using react-bootstrap, can probably remove the "position"
   * CSS
   */
  return (
    <div
      style={{
        width: `${width}px`,
        background: "#ddd",
        position: px !== undefined ? "absolute" : "relative",
        top: py !== undefined && `${py}px`,
        left: px !== undefined ? `${px}px` : `${scrollable_px * -1}px`,
        minHeight: "400px",
        zIndex: "300",
      }}
      className={"scrollable-transition-ease-multirun solid-grey-border"}
      onMouseDown={onDragStart}
    >
      <div
        style={{
          width: "375px",
          lineHeight: "92%",
          transform: `rotate(-90deg) translate(-${
            !run.loading ? labelOffset || translation_px_obj["loaded"] : translation_px_obj["loading"]
          }px, -170px)` /* Must be a better way of doing this */,
        }}
      >
        {!run.loading ? (
          <>
            {!run.err && (
              <>
                <RunInfoPopover run={run} intl={intl} />
                &nbsp;
              </>
            )}
            {
              <span style={{ fontSize: "95%" }}>
                {isLTPM && !run.err ? `${run.reactor} - ${runLabel}` : runLabel}
              </span>
            }
            {run.finished_on && !run.err ? null : (
              <span className={"bordered"} style={detailStyle} title={get_updated_time_label(run, intl)}>
                {getTextStr("general.live", "LIVE")}
              </span>
            )}
            {!run.err && (
              <>
                &nbsp;
                <LabelingCompleteLabel run={run} customStyle={detailStyle} />
                &nbsp;
                {canAlterOffset && (
                  <SetOffsetTrigger
                    offset={perRunTimeOffsets?.[runID] || 0}
                    setOffsetForRun={updateTimeOffset}
                    run_id={runID}
                    intl={intl}
                  />
                )}
                &nbsp;
                <ExcelTravelerButton runData={run} intl={intl} isBtn={false} />
                {canDownloadRawData && (
                  <RunFilesDownloader fileList={run.fileList} exportBaseName={exportBaseName || runLabel} />
                )}
              </>
            )}
            {canUnselectRun && (
              <span
                title={getTextStr("general.remove", "Remove")}
                style={spanStyle}
                onClick={() => toggleRun(runID, false)}
              >
                <span className="fa fa-times" aria-hidden="true" />
              </span>
            )}
            <span
              title={getTextStr("general.refresh", "Refresh")}
              style={spanStyle}
              onClick={run.forceReload}
            >
              <span className="fa fa-refresh" aria-hidden="true" />
            </span>
          </>
        ) : (
          <>
            <span className="fa fa-refresh" aria-hidden="true" />
            &nbsp;&nbsp;{<span style={{ fontSize: "95%" }}>{runLabel}</span>}
          </>
        )}
      </div>
    </div>
  )
}

export default withZoomState(RunHeaderBar)
